export {
  getCompanyAwards,
  getCompanyContents,
  getCompanyDetail,
  getCompanyGroups,
  getCompanyList,
  getFeaturedCompanyList,
  getFollowedCompanies,
  getFollowedCompanyIds,
  getGoldenCompanyList,
  insertCompanyFeedback,
  toggleFollowCompany,
} from '@/features/company/api/company.api';

export { companyQueryKeys } from '@/features/company/api/company.keys';

export {
  useCompanyAwards,
  useCompanyGetGroups,
  useFollowCompany,
  useFollowedCompanyIds,
  useGetCompanyContents,
  useGetCompanyDetail,
  useGetCompanyFollowedCompanies,
  useGetCompanyList,
  useGetFeaturedCompanyList,
  useGetGoldenCompanyList,
  useInsertCompanyFeedback,
} from '@/features/company/api/company.queries';

export type { CompanyAwardItem } from '@/features/company/types/company-awards.types';
export type {
  CompanyListParams,
  FollowedCompaniesParams,
} from '@/features/company/types/company-list.types';
